import React from 'react';
import { GridCell, Grid } from '@fuww/library/src/Grid';
import PropTypes, { InferProps } from 'prop-types';
import { Breadcrumbs } from '@fuww/library/src/Breadcrumb';
import Title from '@fuww/library/src/Title';
import Introduction from '@fuww/library/src/Introduction';
import { useIntl } from 'react-intl';
import HomeLink from '../../HomeLink';
import Head from '../../Head';
import LinkAndAnchor from '../../LinkAndAnchor';
import { useSiteContext } from '../../SiteContext';
import messages from '../../../lib/messages.mjs';

const jobListLayoutPropertyTypes = {
  breadcrumbLabel: PropTypes.string.isRequired,
  listPrefix: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

type JobListLayoutProperties = InferProps<typeof jobListLayoutPropertyTypes>;

const JobListLayout = ({
  breadcrumbLabel,
  listPrefix,
  children,
}: JobListLayoutProperties) => {
  const intl = useIntl();
  const { jobsLocale, jobsComplete } = useSiteContext();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route={`jobs.${jobsLocale}`}
      useRouter={jobsComplete}
    >
      {intl.formatMessage(messages.jobs)}
    </LinkAndAnchor>,
    <LinkAndAnchor
      useRouter={jobsComplete}
      route={`${listPrefix}.${jobsLocale}`}
    >
      {breadcrumbLabel}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages[`${listPrefix}.title`])}
        description={intl
          .formatMessage(messages[`${listPrefix}.description`])}
      />
      <Grid>
        <GridCell padding="0 16px 20px">
          <Breadcrumbs
            crumbs={breadcrumbs}
          />
          <Title tag="h1">
            {intl.formatMessage(messages[`${listPrefix}.title`])}
          </Title>
          <Introduction>
            {intl.formatMessage(messages[`${listPrefix}.introduction`])}
          </Introduction>
          {children}
        </GridCell>
      </Grid>
    </>
  );
};

JobListLayout.propTypes = jobListLayoutPropertyTypes;

export default JobListLayout;
